import { NgIf } from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatButton, MatButtonModule, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {Router, RouterLink} from '@angular/router';
import { AuthenticationService } from '../../../../security/auth/authentication.service';
import { AccountType } from '../../../../enums/accountType';

@Component({
  selector: 'app-profile-menu',
  standalone: true,
  imports: [
    NgIf,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    RouterLink
  ],
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.css'
})
export class ProfileMenuComponent implements OnInit {
  username: string = '';
  email: string = '';
  iconName:string = 'person';
  constructor(private readonly router: Router, private readonly auth: AuthenticationService) {
  }

  ngOnInit(): void {
    const currentUser = this.auth.getCurrentUser2();
    // Prefer the account holder's name (JWT `printedName` claim) over the
    // email in `userName`; fall back to email if a name wasn't captured.
    const clean = (v?: string) => (v ?? '').replaceAll("\"", "").trim();
    this.email = clean(currentUser?.userName);
    // "First Last" (displayName claim), else the e-signature text, else the e-mail.
    this.username = clean(currentUser?.displayName) || clean(currentUser?.printedName) || this.email;
    if (currentUser?.accountType == AccountType.INDIVIDUAL_OWNER){
      this.iconName = 'person';
    }
    if (currentUser?.accountType == AccountType.INDIVIDUAL_BED){
      this.iconName = "bed";
    }
    if (currentUser?.accountType == AccountType.PROPERTY_MANAGEMENT){
       this.iconName = 'domain_add'
    }
  }

  logout() {
    this.auth.logout()
    this.redirectToLogin();
  }

  redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}
